export const translations = {
  stock: {
    pt: 'Saldo em estoque',
    en: 'Balance in stock',
    de: 'Restbetrag auf Lager',
    es: 'Saldo en existencias',
  },
  pending: {
    pt: 'Pendente de regularização',
    en: 'Pending regularization',
    de: 'Ausstehende Regularisierung',
    es: 'Pendiente de regularización',
  },
  movement: {
    pt: 'Movimentações',
    en: 'Movements',
    de: 'Bewegungen',
    es: 'Movimientos',
  },
  dashboard: {
    pt: 'Dashboard',
    en: 'Dashboard',
    de: 'Dashboard',
    es: 'Dashboard',
  }
};
